<template>
  <v-dialog
    v-model="dialog"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
    scrollable
    :persistent="innerLoading != false"
    max-width="65vw"
  >
    <v-card max-height="65vh">
      <v-toolbar dark dense class="white--text" flat>
        <v-toolbar-title class="font-weight-regular my-4"
          >Leads duplicados</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-0 pb-0" min-height="325">
        <v-list v-if="leadsDuplicados?.Lead?.length">
          <v-list-item-group>
            <div v-for="(item, index) in leadsDuplicados.Lead" :key="item._id">
              <div v-if="item._id !== lead._id">
                <v-list-item>
                  <v-list-item-avatar size="25">
                    <v-img
                      :src="getSourceLeadDuplicado(item.contact?.source)"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle class="caption grey--text"
                      >Creado:
                      {{ formatDate(item.created_at) }}</v-list-item-subtitle
                    >
                    <v-list-item-title>
                      {{ item.contact_lead.name }}

                      <ContactDataDuplicateVue
                        :originalContactLead="lead.contact_lead"
                        :compareContactLed="item.contact_lead"
                        field="name"
                        :source="getSourceId(lead.contact?.source)"
                      />
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      Asignado a:
                      {{
                        getBrokerAsignedLeadDuplicado(item.contact_broker_id)
                      }}
                    </v-list-item-subtitle>

                    <v-list-item-subtitle>
                      Telefono: {{ item.contact_lead.phone }}
                      <ContactDataDuplicateVue
                        :originalContactLead="lead.contact_lead"
                        :compareContactLed="item.contact_lead"
                        field="phone"
                        :source="getSourceId(lead.contact?.source)"
                      />
                    </v-list-item-subtitle>

                    <v-list-item-subtitle>
                      Correo:
                      {{ item.contact_lead.email }}
                      <ContactDataDuplicateVue
                        :originalContactLead="lead.contact_lead"
                        :compareContactLed="item.contact_lead"
                        field="email"
                        :source="getSourceId(lead.contact?.source)"
                      />
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <lead-postpone-action
                      :postponed="item.postponed ? item.postponed.date_at : ''"
                      :leadId="item._id"
                      :lead="item"
                    />
                  </v-list-item-action>
                </v-list-item>

                <v-divider
                  v-if="index < leadsDuplicados.length - 1"
                  :key="index"
                ></v-divider>
              </div>
            </div>
          </v-list-item-group>
        </v-list>
        <v-container v-else>
          <v-img
            contain
            max-height="300"
            src="../../../../public/img/undraw_No_data_re_kwbl.png"
          >
          </v-img>
          <v-row justify="center" align="center">
            <v-col cols="12" justify="center" align="center">
              <div class="title">
                Vaya, parece que no hay leads duplicados por mostrar.
              </div>
            </v-col>
            <v-col cols="12" justify="center" align="center">
              <div class="subtitle-2 grey--text">
                No se encontraron leads duplicados automaticamente, intenta
                usando el buscador.
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LeadDuplicatesModal",
  components: {
    ContactDataDuplicateVue: () =>
      import("@/components/lead/components/ContactDataDuplicate.vue"),
    LeadPostponeAction: () => import("@/components/lead/LeadPostpone.vue")
  },
  props: {
    dialog: { type: Boolean, default: false },
    lead: { type: Object, required: true },
    leadsDuplicados: { type: Object, required: true },
    innerLoading: { type: Boolean, default: false }
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    formatDate(date) {
      if (!date) return "";
      const newDate = new Date(date);
      return newDate.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    getSourceLeadDuplicado(idSourcelead) {
      const source = this.filters.sources.find(
        source => source.source_id === idSourcelead
      );
      return source ? source.source.media.src : "";
    },
    getBrokerAsignedLeadDuplicado(idBrokerAsignedlead) {
      const broker = this.filters.contacts.find(
        brk => brk._id === idBrokerAsignedlead
      );
      return broker ? broker.name : "Sin asignar";
    },
    getSourceId(source) {
      if (typeof source === "object") {
        return source._id;
      } else {
        return source;
      }
    }
  },
  computed: {
    filters() {
      return this.$store.state.leads.filter.filters;
    }
  }
};
</script>
